import React from 'react';
import scrollToElement from 'scroll-to-element';

export default class FocusScroll extends React.Component {
    componentDidMount() {
        scrollToElement(this.el, { align: 'middle' });
    }
    render() {
        return (<div
            ref={(el) => {
                this.el = el;
            }}
        />);
    }
}



// WEBPACK FOOTER //
// ./src/client/Components/FocusScroll.js